import React from "react";
import Container from "@/components/marketing/Container";
import { ShieldCheck, Eye, Layers } from "lucide-react";
import SectionHeading from "@/components/marketing/SectionHeading";
import Reveal from "@/components/marketing/Reveal";

const POINTS = [
  { icon: ShieldCheck, title: "Guaranteed pickups", desc: "Named sites, confirmed in advance." },
  { icon: Eye, title: "Transparent reach", desc: "You see the network before you buy." },
  { icon: Layers, title: "One platform", desc: "Newswire, earned, and guaranteed together." },
];

export default function NewswireWhyUs() {
  return (
    <section className="bg-[#f7f7f9] py-10 sm:py-12 lg:py-14">
      <Container>
        <Reveal>
          <SectionHeading
            tag="WHY DIGITAL24"
            title="Defined reach, not a mystery blast."
            subtitle="Every newswire shows exactly which sites, regions, and pickups you get, no vague networks, no guesswork, and it extends across every channel."
          />
        </Reveal>
        <div className="grid sm:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {POINTS.map((p, index) => {
            const Icon = p.icon;
            return (
              <Reveal variant="card" delay={index * 0.08} key={p.title}>
                <div className="bg-white border-[0.5px] border-[#e8e6ef] rounded-[14px] p-7 transition-shadow hover:shadow-md">
                  <div className="inline-flex items-center justify-center w-10 h-10 rounded-lg mb-5 bg-cobalt/10">
                    <Icon className="w-5 h-5 text-cobalt" strokeWidth={2} />
                  </div>
                  <h3 className="font-heading text-base font-semibold text-bone mb-2">{p.title}</h3>
                  <p className="text-[15px] text-steel leading-[1.6]">{p.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </section>
  );
}